import React from 'react'
import { connect } from 'react-redux'
import { AbstractBankingComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import * as SVG from '~/assets/svg'
import * as route from '~/helper/constant/route'
import { withTranslation } from 'react-i18next'

class BankingComponent extends AbstractBankingComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }

    render() {
        const {t} = this.props
        return (
            <div className="main-page">
                <Sidebar id="banking" isAccount={true}/>
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.accounting.menu}>{t('sidebar:account')} &nbsp; &gt; &nbsp;</a>
                            </li>
                            <li>
                                {t('banking:banking')}
                            </li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('banking:banking')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="folder-page">
                        <div className="row clearfix">
                            <div className="float-left course-your">
                                <div className="folder-list clearfix" onClick={() => (window.location = route.admin.accounting.banking.account.view)}>
                                    <a href={route.admin.accounting.banking.account.view} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.banking.account.view} className="folder-name">
                                        {t('sidebar:account')}
                                        <span> {t('banking:manageAccount')}</span>
                                    </a>
                                </div>
                            </div>

                            <div className="float-left course-your">
                                <div className="folder-list clearfix" onClick={() => (window.location = route.admin.accounting.banking.transfer.view)}>
                                    <a href={route.admin.accounting.banking.transfer.view} className="folder-img">
                                        {SVG.studentcategory()}
                                    </a>
                                    <a href={route.admin.accounting.banking.transfer.view} className="folder-name">
                                        {t('banking:transfer')} 
                                        <span> {t('banking:manageTransfer')}</span>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

const Banking = withTranslation()(connect(mapStateToProps)
(BankingComponent))

export {Banking}
